var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmaiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.9643 13H10.5357C9.53168 13 8.56877 13.4004 7.85881 14.113C7.14885 14.8256 6.75 15.7922 6.75 16.8V47.2C6.75 48.2078 7.14885 49.1744 7.85881 49.887C8.56877 50.5996 9.53168 51 10.5357 51H55.9643C56.9683 51 57.9312 50.5996 58.6412 49.887C59.3512 49.1744 59.75 48.2078 59.75 47.2V16.8C59.75 15.7922 59.3512 14.8256 58.6412 14.113C57.9312 13.4004 56.9683 13 55.9643 13ZM51.8 16.8L33.25 29.682L14.7 16.8H51.8ZM10.5357 47.2V18.529L32.1711 33.558C32.4879 33.7786 32.8644 33.8969 33.25 33.8969C33.6356 33.8969 34.0121 33.7786 34.3289 33.558L55.9643 18.529V47.2H10.5357Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmaiIcon);
export default __webpack_public_path__ + "static/media/emaiIcon.e15e1ab7aaf9330c99d467c75e530779.svg";
export { ForwardRef as ReactComponent };